/* tslint:disable */
/* eslint-disable */
/**
 * Trendtours CMS API
 * ISO API for the IBE. 
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ApiSiteSuggestionResponse
 */
export interface ApiSiteSuggestionResponse {
    /**
     * 
     * @type {string}
     * @memberof ApiSiteSuggestionResponse
     */
    country?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiSiteSuggestionResponse
     */
    url?: string;
}

export function ApiSiteSuggestionResponseFromJSON(json: any): ApiSiteSuggestionResponse {
    return ApiSiteSuggestionResponseFromJSONTyped(json, false);
}

export function ApiSiteSuggestionResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiSiteSuggestionResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'country': !exists(json, 'country') ? undefined : json['country'],
        'url': !exists(json, 'url') ? undefined : json['url'],
    };
}

export function ApiSiteSuggestionResponseToJSON(value?: ApiSiteSuggestionResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'country': value.country,
        'url': value.url,
    };
}


// custom code here ##################################################################################################################
function toUTC(date) {
  var date_utc =  Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds());
  return new Date(date_utc);
}
